import * as React from "react";
import { useAccessStore } from "../lib/store/useAccessStore";
import { useMyInfo } from "../@apis/hooks/useAuth";
import { useQuery } from "@tanstack/react-query";
import { useMyInfoStore } from "../lib/store/useMyInfoStore";
import type { MyInfo } from "../types/auth.types";

export function useRefreshMyInfo() {
    const { access } = useAccessStore();
    const { setMyInfo } = useMyInfoStore();

    const { data: myInfoData, isSuccess } = useQuery({
        ...useMyInfo(),
        enabled: !!access.accessToken,
    });
    const { data, success } = myInfoData || {};

    React.useEffect(() => {
        if (isSuccess && success) {
        setMyInfo(data as MyInfo);
        }
    }, [data, isSuccess, setMyInfo, success]);
}